import { bl_fi_my_einvoice_batch_pool_event_RowClass } from '../../dbschema/bl_fi_my_einvoice_batch_pool_event.model';
import { BaseContainerModel } from '../base-container.model';

export class BatchPoolEventContainerModel extends BaseContainerModel {
    bl_fi_my_einvoice_batch_pool_event: bl_fi_my_einvoice_batch_pool_event_RowClass = new bl_fi_my_einvoice_batch_pool_event_RowClass();
}
